import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import UnAuthLayout from "./layout/UnAuthLayout";
import { Route, useNavigate } from "react-router";
import { Routes } from "react-router";
import colors from "./style.module.scss";

import AuthLayout from "./layout/AuthLayout";
import LivePlatformPage from "./pages/LivePlatformPage/LivePlatformPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import LiveProductionPage from "./pages/LiveProductionPage/LiveProductionPage";
import EngageTranslationPage from "./pages/EngageTranslationPage/EngageTranslationPage";
import { initializeIcons } from "@fluentui/react";
import { initializeFileTypeIcons } from "@fluentui/react-file-type-icons";
import TranslationDetailPage from "./pages/TranslationDetailPage/TranslationDetailPage";
import { Button, ConfigProvider } from "antd";
import { Amplify } from "aws-amplify";
import APP_CONFIG from "./configs/environment";
import { Provider, useSelector } from "react-redux";
import store, { RootState } from "./redux/Store";
import FileUploadNotification from "./components/EngageTranslationComponent/FileUploadComponent/FileUploadNotification";
import AuditLogPage from "./pages/AuditLogPage/AuditLogPage";
import ConfirmLogoutModal from "./components/Template/ConfirmLogoutModal";
import ErrorPage from "./pages/template/ErrorPage/ErrorPage";
import { useIdleTimer } from "react-idle-timer";
import { getSessionData } from "./services/auth/AuthAPI";
import { useAppDispatch } from "./redux/useAppDispatch";
import { fetchDocuments, fetchSearchTabs, updateTab } from "./redux/EngageTranslation/EngageTranslationAction";
import { registerLicense } from "@syncfusion/ej2-base";
import QuickTextTranslatePage from "./pages/QuickTextTranslatePage/QuickTextTranslatePage";

Amplify.configure(APP_CONFIG.amplify_config);
registerLicense("ORg4AjUWIQA/Gnt2UlhhQlVMfV5DQmpWfFN0QXNYf1RzfF9GYkwgOX1dQl9nSH5SdkRjWndaeXxSQmM=");
function App() {
  initializeIcons(); // Initialize Fluent UI icons
  initializeFileTypeIcons(undefined);
  const navigate = useNavigate();

  const onIdle = () => {
    navigate("/");
  };

  // Logs out user after 20 minutes of idle time
  useIdleTimer({
    onIdle,
    timeout: 1200_000,
    throttle: 500,
  });

  return (
    <Provider store={store}>
      <FileUploadNotification />

      <ConfigProvider
        theme={{
          token: { colorPrimary: colors.colorPrimary },
        }}>
        <Routes>
          <Route
            path=""
            element={<UnAuthLayout />}>
            <Route
              path=""
              element={<LoginPage />}>
              <Route
                path="login"
                element={<LoginPage />}
              />
            </Route>
          </Route>

          <Route
            path="documents"
            element={<AuthLayout />}>
            <Route
              path=""
              element={<EngageTranslationPage />}
            />

            <Route
              path=":documentId/view-document/:id"
              element={<TranslationDetailPage />}
            />
            <Route
              path="quick-text-translate"
              element={<QuickTextTranslatePage />}
            />
            <Route
              path=":auditId/audit-log"
              element={<AuditLogPage />}
            />
          </Route>

          <Route
            path="*"
            element={
              <ErrorPage
                errorMessage="404 - Page Not Found."
                errorDescription="The page you're looking for might have been moved, deleted, or it could be temporarily unavailable."
                actionBtn={
                  <button
                    className="button"
                    onClick={() => navigate("/documents")}>
                    Return
                  </button>
                }
              />
            }
          />
        </Routes>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
